import { getPromise, deletePromise, postPromise, putPromise } from './request';
import { getFullUrl } from '../util/pure_functions/utils';
import { isValidValue, getDateInFormat  } from '../util/utils';
import pickBy from 'lodash/pickBy';



export function indexCommentsForAccount({accountId, page, status, sortOrder, mquery, filters, spam, orderBy, fromDate, toDate, domains}) {
  const params = pickBy({
    'account_id': accountId,
    'page': (page || 1),
    'sort_order': sortOrder,
    'order_by': orderBy,
    'status': status,
    'mquery': mquery,
    'filters': filters,
    'spam': spam,
    'from_date': getDateInFormat(fromDate),
    'to_date': getDateInFormat(toDate),
    'domains[]': domains
  }, isValidValue);
  return getPromise(`/api/v1/admin/comments`, params);
}

export function deleteComment(commentIds, accountId) {
  if (commentIds) {
    return deletePromise(`/api/v1/admin/comments`, {'comment_ids': commentIds, 'account_id': accountId});
  }
}

export function authCallback(provider) {
  return getPromise(`users/auth/${provider}/callback`);
}

export function postAuthCallback(provider, params) {
  return postPromise(`users/auth/${provider}/callback?code=${params.code}&redirect_uri=postmessage`, params);
}

export function currentUser() {
  return getPromise(`api/v1/admin/current_user.json`);
}

export function logOutUser() {
  return deletePromise(`api/v1/admin/current_user.json`);
}

export function getAllUsers(accountId, params = {}) {
  return getPromise(`api/v1/admin/accounts/${accountId}/users`, params);
}

export function submitStory(accountId, contribution) {
  return postPromise(getFullUrl(`api/v1/accounts/${accountId}/contributions`), {
    contribution: contribution
  });
}

export function onCommentAction(commentIds, accountId, userId, actionName) {
  if (commentIds) {
    return postPromise(`/api/v1/admin/comments/${actionName}`, {'comment_ids': commentIds, 'account_id': accountId, 'user_id': userId});
  }
}

export function subscribePlan(userId, planId) {
  return postPromise(`/api/v1/admin/users/${userId}/subscriptions`, {"plan_id": planId});
}

export function createAccount(userId, accountDetailsRazorpayIds) {
  return postPromise(`/api/v1/admin/users/${userId}/accounts`, accountDetailsRazorpayIds);
}

export function commentTimeline(commentId, accountId) {
  return getPromise(`/api/v1/admin/comments/${commentId}`, {'account_id': accountId});
}

export function updateAccount(accountId, params) {
  return putPromise(`/api/v1/admin/accounts/${accountId}`, params);
}

export function updateProfileData(params) {
  return putPromise('api/v1/admin/current_user.json', params);
}


export function createAdminUser(accountId, params) {
  return postPromise(`/api/v1/admin/accounts/${accountId}/users`, params);
}

export function contactUs(contact_us) {
  return postPromise(`api/v1/admin/contact_us_details`, {
    contact_us
  })
}



// WEBPACK FOOTER //
// ./app/javascript/gateway/backend.js